'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _FormatIndicator = require('./components/FormatIndicator.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_FormatIndicator).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/format-indicator/lib/index.js
// module id = 177
// module chunks = 1